import { render, staticRenderFns } from "./TerminateWithhold.vue?vue&type=template&id=e2ea4c2e&scoped=true"
import script from "./TerminateWithhold.vue?vue&type=script&setup=true&lang=js"
export * from "./TerminateWithhold.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TerminateWithhold.vue?vue&type=style&index=0&id=e2ea4c2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ea4c2e",
  null
  
)

export default component.exports